/* eslint-disable */
import { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

function NetworkChecker() {
  const { data, setData } = useDataContext();
  const hasCheckedRef = useRef(false); // กันไม่ให้เช็คซ้ำ

  useEffect(() => {
    if (data.province !== "" || hasCheckedRef.current) return;

    hasCheckedRef.current = true; // ทำงานแค่ครั้งเดียว

    const checkConnection = async () => {
      setData((prevData) => ({
        ...prevData,
        spin: true,
      }));

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      try {
        const response = await fetch('https://api-hr.boonsiri.co.th/provinces', {
          method: 'GET',
          cache: 'no-cache',
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        setData((prevData) => ({
          ...prevData,
          spin: false,
        }));
      } catch (error) {
        clearTimeout(timeoutId);

        setData((prevData) => ({
          ...prevData,
          alert: true,
          alertIcon: 'error',
          alertText: 'ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่อีกครั้ง',
          alertTitle: 'error',
          alertFooter: '',
          onClickReload: true,
          spin: false,
        }));

        console.error('Network check failed:', error.message);
      }
    };

    checkConnection();
  }, [data.province, setData]);

  return null;
}

export default NetworkChecker;
